// Shared helpers for Quote API modules
import type { PaginatedResponse } from '@quotech/api'
import type { AxiosRequestConfig } from 'axios'
import { getApiClient, getOrganisationIdForRequests } from './setupApi'

export { getApiClient }

export function withOrgConfig(config?: AxiosRequestConfig): AxiosRequestConfig {
  return {
    ...(config || {}),
    params: {
      org_id: getOrganisationIdForRequests(),
      ...((config?.params as Record<string, unknown>) || {}),
    },
  }
}

export function asArray<T>(data: PaginatedResponse<T> | T[] | null | undefined): T[] {
  if (!data) return []
  if (Array.isArray(data)) return data
  if (data && typeof data === 'object' && 'results' in data) {
    return Array.isArray(data.results) ? data.results : []
  }
  return []
}
